
const data = [
    {
      level:"🌶🌶🌶High",
      id: 1
    },
    {
      level:"🌶🌶Medium",
      id: 2
    },
    {
      level:"🌶Low",
      id: 3
    },
  ];
  export default data;